export default {
    
    indexActivityItemTeachers:      { method: 'get',    url: 'activity_item_teachers' },
    createActivityItemTeacher:      { method: 'post',   url: 'activity_item_teachers'},
    updateActivityItemTeacher:      { method: 'put',    url: 'activity_item_teachers/{id}'},
    deleteActivityItemTeacher:      { method: 'delete', url: 'activity_item_teachers/{id}' },
}